export default __webpack_public_path__ + "static/media/redArrow.09f76313.svg";